import {useRef} from "react";

export function arraysShallowEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (a.length !== b.length) {
        return false;
    }
    return a.every((value, index) => value === b[index]);
}

// Keeps returning the same reference across renders as long as `isEqual` says
// the new value is equivalent to the previous one.
export function useStable(value, isEqual) {
    const ref = useRef(value);
    if (!isEqual(ref.current, value)) {
        ref.current = value;
    }
    return ref.current;
}
